import { useId } from 'react';
import { getQTipData } from '../Tooltip/qTip.utilities';
import type { CheckboxProps } from './Checkbox.types';

const alignment = 'tw:flex';
const labelClasses = 'tw:ml-1.5 tw:text-sm tw:-mt-0.5';

const baseClasses =
  'tw:appearance-none tw:border tw:h-3.5 tw:w-3.5 tw:shrink-0 tw:focus:ring-0 tw:focus:ring-offset-0 tw:outline-none tw:focus:outline-none' +
  ' tw:dark:bg-sq-dark-background tw:dark:border-sq-dark-text tw:dark:enabled:hover:bg-sq-dark-background' +
  ' tw:checked:text-white tw:checked:border-sq-text-color tw:checked:enabled:hover:border-sq-theme-dark' +
  ' tw:checked:active:border-sq-theme-darker tw:checked:focus:border-sq-theme-dark tw:disabled:border-sq-disabled-gray' +
  ' tw:dark:disabled:border-sq-fairly-dark-gray tw:dark:checked:focus:bg-sq-dark-background';

const checkboxClasses = `tw:rounded ${baseClasses}`;

const radioClasses = `tw:rounded-full ${baseClasses}`;

/**
 * Checkbox and Radio Box Component.
 */
export const Checkbox = (props: CheckboxProps) => {
  const {
    type = 'checkbox',
    value,
    disabled = false,
    label,
    onChange,
    onClick,
    onKeyDown,
    checked,
    defaultChecked,
    id,
    name,
    extraClassNames = '',
    extraLabelClassNames,
    testId,
    ...tooltipProps
  } = props;

  const reactId = useId();
  const assignedId = id ?? `checkbox${reactId}`;
  const tooltipData = getQTipData(tooltipProps);

  return (
    <span className={`${alignment} ${extraClassNames}`}>
      <input
        value={value}
        type={type}
        data-testid={testId}
        name={name}
        id={assignedId}
        readOnly={!onChange}
        checked={checked}
        defaultChecked={defaultChecked}
        className={`${type === 'checkbox' ? checkboxClasses : radioClasses} ${
          disabled ? 'tw:cursor-not-allowed' : 'tw:cursor-pointer'
        }`}
        disabled={disabled}
        onClick={onClick}
        onChange={onChange}
        onKeyDown={onKeyDown}
        {...tooltipData}
      />
      {label && (
        <label
          htmlFor={assignedId}
          className={`${labelClasses} ${extraLabelClassNames} ${
            disabled
              ? 'tw:cursor-not-allowed tw:dark:text-sq-fairly-dark-gray tw:text-sq-fairly-dark-gray'
              : 'tw:cursor-pointer tw:text-sq-text-color tw:dark:text-sq-dark-text'
          }`}>
          {label}
        </label>
      )}
    </span>
  );
};
